import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import md5 from 'md5'
import { toast } from '../Components/ui'
import Api from '../Services/Api'

export default class TableDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: null,
      soci: [],
      selectedSoci: []
    }
  }

  async componentDidMount () {
    const user = this.props.data
    this.setState({ user })
    await this.getSociFornitori(user)
  }

  async passwordReset () {
    const { user } = this.state
    const hash = md5((user.email).toString())
    const password = hash.substring(hash.length - 8, hash.length)

    const res = await Api.patch(`/users/${user._id}`, { password, firstLogin: true })
    if (res.ok) {
      toast.success('Password reset effettuato con successo')
      this.props.loadData()
    } else {
      toast.error('Impossibile effettuare il password reset')
    }
  }

  async getSociFornitori (user) {
    const ret = await Api.get(`/users/${user._id}`)
    const soci = this.props.soci
    const userSoci = ret.data.soci || []
    const selectedSoci = soci.filter(s => userSoci.includes(s.codFornitore))
    this.setState({ soci, selectedSoci })
  }

  async saveSelectedSoci () {
    const { user, selectedSoci } = this.state
    const soci = selectedSoci.map(s => Number(s.codFornitore))

    const res = await Api.patch(`/users/${user._id}`, { soci })
    if (res.ok) {
      toast.success('Visualizzazione soci aggiornata correttamente')
      this.props.loadData()
    } else {
      toast.error('Impossibile aggiungere i soci, riprovare più tardi')
    }
  }

  deleteSelectedSocio (codFornitore) {
    const { selectedSoci } = this.state
    this.setState({ selectedSoci: selectedSoci.filter(s => s.codFornitore !== codFornitore) })
  }

  render () {
    const { user, soci, selectedSoci } = this.state

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ maxWidth: 600 }}>
          <h6 style={{ fontWeight: 700, marginBottom: 10 }}>Soci visibili nell'app</h6>
          <select
            className='form-select'
            style={{ marginBottom: 10 }}
            disabled={soci.length === 0}
            onChange={e => {
              const item = e.target.value.split('|')
              this.setState({ selectedSoci: [...selectedSoci, { codFornitore: item[0], fornitore: item[1] }] })
            }}
          >
            <option>...</option>
            {soci.map((socio, i) => (
              <option key={i} value={`${socio.codFornitore}|${socio.fornitore}`}>{socio.codFornitore} - {socio.fornitore}</option>
            ))}
          </select>

          {selectedSoci.length > 0 && (
            <div className='ui-table-wrap' style={{ marginBottom: 10 }}>
              <table className='ui-table'>
                <thead>
                  <tr>
                    <th style={{ width: '20%' }}>Codice Fornitore</th>
                    <th>Ragione Sociale</th>
                    <th style={{ width: 80 }} />
                  </tr>
                </thead>
                <tbody>
                  {selectedSoci.map((s, i) => (
                    <tr key={i}>
                      <td>{s.codFornitore}</td>
                      <td>{s.fornitore}</td>
                      <td><Button size='sm' variant='danger' onClick={() => this.deleteSelectedSocio(s.codFornitore)}>Rimuovi</Button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Button variant='warning' size='sm' onClick={() => this.saveSelectedSoci()}>Salva soci</Button>
        </div>

        {user && user.type === 'user' && (
          <div>
            <Button variant='outline-danger' size='sm' onClick={() => this.passwordReset()}>Password reset</Button>
          </div>
        )}
      </div>
    )
  }
}
